<template>
    <div class="content right_side action_block visible" v-if="visible">
        <PhotoReplacementNotice
            v-if="showPhotoReplacementNotice"
            :order="order"
        ></PhotoReplacementNotice>
        <ReviewControls
            v-if="!showPhotoReplacementNotice"
            :order="order"
        ></ReviewControls>

        <div class="row w-100">
            <div class="col-md-6">
                <div class="products_images_slider">
                    <ImageSlider
                        :slides="order.artistImages"
                        :frame="frame"
                        :warranty="order.warranty"
                        :copy_purchased="order.copyPurchased"
                        :shipping_upgrade="
                            orderStore.order_data.customer_data.orderShipping
                        "
                    ></ImageSlider>
                </div>
            </div>
            <div class="col-md-6">
                <LineItemUpgradeSection :order="order"></LineItemUpgradeSection>
            </div>
        </div>
    </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import ImageSlider from "@/components/ImageSlider.vue";
import PhotoReplacementNotice from "@/components/photo-replacement/PhotoReplacementNotice.vue";
import ReviewControls from "@/components/review-controls/ReviewControls.vue";
import LineItemUpgradeSection from "@/components/upgrade-controls/LineItemUpgradeSection.vue";
import { useOrderStore } from "@/stores/order";

export default {
    name: "StepsController",
    components: {
        ImageSlider,
        ReviewControls,
        PhotoReplacementNotice,
        LineItemUpgradeSection,
    },
    props: ["update", "order"],
    data() {
        return {
            orderStore: useOrderStore(),
        };
    },
    mounted() {
        if (
            this.order.egleStatus !== "On Hold" &&
            this.step >= 3 &&
            this.order.artistImages.length === 0
        ) {
            Sentry.captureMessage(
                `No artist images in line item ${this.order.id}`
            );
        }
    },
    computed: {
        visible() {
            return this.orderStore.selectedProduct === this.order.id;
        },
        step() {
            return this.orderStore.getOrderStep(this.order.id);
        },
        showPhotoReplacementNotice() {
            return (
                (this.order.allowFreePhotoChange ||
                    this.order.allowPaidPhotoChange ||
                    this.order.paidPhotoChangesAllowed > 0) &&
                this.step < 4
            );
        },
        frame() {
            const order_frame = this.order.frame ? this.order.frame.trim() : "";
            if (order_frame) {
                return order_frame.toLowerCase();
            }

            const shopify_frame = this.orderStore.order_data.customer_data
                .shopify_frame
                ? this.orderStore.order_data.customer_data.shopify_frame.trim()
                : "";

            if (shopify_frame) {
                return shopify_frame.toLowerCase();
            }

            return "";
        },
    },

    methods: {},
};
</script>
